
<app-authenticate *ngIf="!authenticated">
</app-authenticate>
<app-navigation *ngIf="authenticated">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</app-navigation>
<app-loading></app-loading>